module.exports = __webpack_public_path__ + "static/media/slider-1.5df09561.png";